import { FunctionComponent } from 'react';
import classnames from 'classnames';

import { Props } from './index';
import StyledComponent from './styles';

const PublicPageJobSectionJob: FunctionComponent<Props> = ({
    background,
}) => {
    return (
        <StyledComponent className="public-page-company-site-section-background">
            <div
                className={classnames('company-background', {
                    'blank-background': Boolean(!background),
                })}
            >
                {background && (
                    <div className="company-background-container">
                        <img
                            className="company-background-image"
                            src={background?.imageUrl}
                            alt=""
                            loading="lazy"
                        />
                    </div>
                )}
            </div>
        </StyledComponent>
    );
};

export default PublicPageJobSectionJob;